import React, { useState, useEffect } from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

interface LegalDocument {
  id: string;
  title: string;
  content: string;
  type: 'terms' | 'privacy';
  version: string;
  published_at: string;
}

export default function TermsOfUse() {
  const [document, setDocument] = useState<LegalDocument | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDocument();
  }, []);

  async function fetchDocument() {
    try {
      setLoading(true);
      
      const { data, error } = await supabase
        .from('legal_documents')
        .select('*')
        .eq('type', 'terms')
        .eq('is_active', true)
        .single();
      
      if (error) throw error;
      setDocument(data);
    } catch (error) {
      console.error('Error fetching terms of use:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <FileText className="h-8 w-8 text-brand-teal" />
            <h1 className="text-3xl font-bold text-brand-teal">Termos de Uso</h1>
          </div>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-4 py-2 bg-brand-teal text-white rounded-lg hover:bg-brand-teal/90 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>Voltar</span>
          </button>
        </div>

        <div className="bg-white rounded-xl shadow-sm p-8">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-teal"></div>
            </div>
          ) : document ? (
            <div>
              <div className="mb-6 pb-6 border-b border-gray-200">
                <p className="text-sm text-gray-500">
                  Versão {document.version} • Atualizado em {new Date(document.published_at).toLocaleDateString('pt-BR')}
                </p>
              </div>
              
              <div 
                className="prose max-w-none"
                dangerouslySetInnerHTML={{ __html: document.content }}
              />
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500">Documento não encontrado.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}